// extracted by mini-css-extract-plugin
export var link = "_ts-0";